import React, { useState } from "react";
import { AppBar, Tabs, Tab, Box, Grid } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import TableBarIcon from "@mui/icons-material/TableBar";
import BookIcon from "@mui/icons-material/Book";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import GuestsTab from "./Guests/GuestsTab";
import TablesTab from "./Tables/TablesTab";
import DiaryTab from "./Diary/DiaryTab";
import FinanceTab from "./Finance/FinanceTab";
import SponsoredSlot from "../Sponsored/SponsoredSlot";
import "./Organizer.css";
import NextTasks from "./NextTasks/NextTasks";
import { useAuth } from "../../contexts/AuthContext";

const Organizer = () => {
  const { weddingId } = useAuth();
  const [tabIndex, setTabIndex] = useState(0);
  const [paymentFocus, setPaymentFocus] = useState(0);
  const openTask = (destination) => {
    setTabIndex({ tables: 1, diary: 2, payments: 3 }[destination]);
    if (destination === "payments") setPaymentFocus((value) => value + 1);
  };

  const handleChange = (_, newValue) => setTabIndex(newValue);
  const tabPlacementMap = [
    "organizer.guests.top",
    "organizer.tables.top",
    "organizer.diary.top",
    "organizer.finance.top",
  ];
  const tabPlacement = tabPlacementMap[tabIndex] || tabPlacementMap[0];

  return (
    <Box className="tabs-page-container">
      <NextTasks weddingId={weddingId} activeTab={tabIndex} onOpen={openTask} />
      <AppBar position="static" color="transparent">
        <Tabs
          className="custom-tabs"
          value={tabIndex}
          onChange={handleChange}
          variant="fullWidth"
          textColor="inherit"
        >
          <Tab icon={<PeopleIcon />} label="Гости" />
          <Tab icon={<TableBarIcon />} label="Маси" />
          <Tab icon={<BookIcon />} label="Дневник" />
          <Tab icon={<AccountBalanceWalletIcon />} label="Финансии" />
        </Tabs>
      </AppBar>
      <SponsoredSlot placement={tabPlacement} className="organizer-sponsored-slot" />
      <Grid
        container
        justifyContent="center"
        sx={{ overflow: "hidden", flexGrow: 1 }}
      >
        {tabIndex === 0 && <GuestsTab />}
        {tabIndex === 1 && <TablesTab />}
        {tabIndex === 2 && <DiaryTab />}
        {tabIndex === 3 && <FinanceTab paymentFocus={paymentFocus} />}
      </Grid>
    </Box>
  );
};

export default Organizer;
